<template>
  <div class="content">
    <div class="block block-form" style="padding-bottom: 20px;">
      <div class="tab-wrap">
        <el-tabs v-model="searchForm.status" @tab-click="onStatusChange">
          <el-tab-pane v-for="tab in statusTabs" :key="String(tab.value)" :name="tab.value" :label="tab.label" />
        </el-tabs>
      </div>
      <div class="desc-wrap">
        <p>发票抬头和开票主体分别为，签约时的甲乙双方；订单发票抬头和开票主体一致，会统计到一条开票记录。</p>
        <p>可开票金额说明：结算可开票金额为已结算订单成交金额，退款可扣减金额为已结算退款订单的退款金额，可开票金额=结算可开票金额-退款可扣减金额。</p>
        <p>列表默认按开票月份正序展示。</p>
      </div>
    </div>
    <div class="block block-top">
      <CanInvoiceTab v-if="searchForm.status === '1'" :list="list" :list-loading="listLoading" :page="searchForm.page"
        :total="total" @page-change="changePage" @page-size-change="changePageSize" @apply="openApplyDialog" />
      <InvoicingTab v-else-if="searchForm.status === '2'" :list="list" :list-loading="listLoading"
        :page="searchForm.page" :total="total" @page-change="changePage" @page-size-change="changePageSize" />
      <InvoicedTab v-else :list="list" :list-loading="listLoading" :page="searchForm.page" :total="total"
        @page-change="changePage" @page-size-change="changePageSize" @download="downloadInvoice" />
    </div>
    <ApplyDialog ref="applyDialogRef" @success="handleApplySuccess" />
  </div>
</template>
<script>
import { getInvoiceList } from '@/api/invoice'
import ApplyDialog from './modules/ApplyDialog'
import CanInvoiceTab from './modules/CanInvoiceTab'
import InvoicingTab from './modules/InvoicingTab'
import InvoicedTab from './modules/InvoicedTab'

export default {
  name: 'Invoice',
  components: {
    ApplyDialog,
    CanInvoiceTab,
    InvoicingTab,
    InvoicedTab
  },
  data() {
    return {
      listLoading: false,
      total: 0,
      statusTabs: [
        { label: '可开票', value: '1' },
        { label: '开票中', value: '2' },
        { label: '已开票', value: '3' }
      ],
      searchForm: {
        status: '1',
        page: 1,
        pagesize: 10
      },
      list: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    onStatusChange() {
      this.searchForm.page = 1
      this.getList()
    },
    changePage(page) {
      this.searchForm.page = page
      this.getList()
    },
    changePageSize(pageSize) {
      this.searchForm.pagesize = pageSize
      this.searchForm.page = 1
      this.getList()
    },
    handleApplySuccess() {
      this.searchForm.page = 1
      this.getList()
    },
    async getList() {
      this.listLoading = true
      const params = {
        status: this.searchForm.status,
        page: this.searchForm.page,
        pagesize: this.searchForm.pagesize
      }
      try {
        const response = await getInvoiceList(params)
        const responseData = response.data || {}
        this.list = responseData.list || []
        this.total = Number(responseData.total || 0)
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
    openApplyDialog(row) {
      this.$refs.applyDialogRef.open(row, this.searchForm.status)
    },
    downloadInvoice(row) {
      if (!row || !row.download_url) {
        this.$Message.warning('暂无可下载发票')
        return
      }
      window.open(row.download_url)
    }
  }
}
</script>
<style scoped lang="less">
.tab-wrap {
  margin-top: 8px;
}

.desc-wrap {
  margin-top: 8px;
  padding: 12px;
  background: #f5f9ff;
  border-radius: 4px;
  color: #4e5969;
  line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/invoice/index.vue